import { useTheme } from "@mui/material";
import { Dispatch, SetStateAction, useState } from "react";
import type { LearningObject } from "types";
import { StarIcon, StarsBoxContainer } from "./CtaOverlay.styles";
import { getIconsRating } from "./utils";
import { useRatingMutation } from "../../queries";
import { getLearningObjectType } from "../../utils/general";

export const StarsBox =({
  id,
  learningObjectTypology,
  maxRating,
  userRating,
  visibility,
  setActiveIndex,
  stopTimer,
  startTimer

}: Pick<
    LearningObject,
    | "id"
    | "learningObjectTypology"
  > & {
  maxRating:number
  userRating: number
  visibility: boolean
  setActiveIndex:  Dispatch<SetStateAction<number | undefined>>
  stopTimer: () => void
  startTimer: () => void
})=> {
  const theme = useTheme();
  const iconsRating = getIconsRating(maxRating);
  const learningObjectType = getLearningObjectType(learningObjectTypology);
  const { mutate: addRating } = useRatingMutation({
    learningObjectId: id.toString(),
    learningObjectType
  });

  const [hover, setHover] = useState<{
    isHover: boolean,
    indexHover: number
  }>({
    isHover: false,
    indexHover: 0
  });

  function handleFIll(index: number){
    if((index + 1) <= userRating) {
      return theme.customColors.systemSecondary01; 
    }
    return "transparent";
  }
  function handleStroke(index: number){
    if(!hover.isHover && ((index + 1) <= userRating)) {
      return theme.customColors.systemSecondary01; 
    }
    if(!hover.isHover && ((index + 1) > userRating)){
      return theme.customColors.textPrimary;
    }
    if(hover.isHover && (hover.indexHover > index)){
      if(((index + 1) <= userRating)) return theme.customColors.systemSecondary01;
      return theme.customColors.systemSecondary01;
    }
    if(hover.isHover && ((index + 1) <= userRating)) return theme.customColors.systemSecondary01;
    return theme.customColors.textPrimary;
  }
  

  return ( 
    <StarsBoxContainer 
      $visibility={ visibility }
    >
      { iconsRating.map((icon, index) =>  (
        <StarIcon 
          tabIndex={ 0 }
          size={ "1rem" }
          fill={ handleFIll(index) }
          stroke={ handleStroke(index) }
          className="star-icon"  
          id={ "star-icon-" + { index } }
          key={ icon.point + index } 
          onClick={ () => {
            addRating({ rating: icon.point });
          } }
          onMouseOver={ () => setHover({ isHover:true, indexHover: index +1 }) }
          onFocus={ () => { 
            setActiveIndex(1); 
            stopTimer();
          } }
          onBlur={ undefined }
          onMouseEnter={ ()=> {
            setActiveIndex(1);
            stopTimer();
            setHover({ isHover:true, indexHover: index +1 });
          } }
          onMouseLeave={ ()=> {
            setActiveIndex(undefined);
            startTimer();
            setHover({ isHover:false, indexHover: 0 });
          } }
          onKeyDown={ (e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              addRating({ rating: icon.point });
            }
          } }
        />
      )) }
    </StarsBoxContainer>
  );
};
